import { BottomSheet, Button, Typography } from '@bharatpe/bharat-ui';
import React, { useEffect, useState } from 'react';

interface IProps {
	handleModalClose: (...args: any[]) => void;
	handleClickPrimary: (...args: any[]) => void;
	handleClickSecondary: (...args: any[]) => void;
	title: string;
	description: string;
	primaryButtonName: string;
	secondaryButtonName: string;
	icon: string;
	type: string;
}

const WrongPinModal: React.FC<IProps> = ({
	handleModalClose,
	handleClickPrimary,
	handleClickSecondary,
	title,
	description,
	primaryButtonName,
	secondaryButtonName,
	icon,
	type,
}) => {
	const [showModal, setShowModal] = useState(false);
	useEffect(() => {
		setShowModal(true);
	}, []);
	return (
		<BottomSheet visible={showModal} showCloseButton={false} onClose={handleModalClose} heading="" rounded>
			<div className="flex flex-column p4">
				<img src={icon} className="mb4" width={'48px'} height={'48px'} />
				<div className="flex flex-column">
					<Typography variant="Bold500 mb2" className={type == 'danger' ? 'danger' : ''} component="span">
						{title}
					</Typography>
					<Typography variant="Light200" className="grey" component="span">
						{description}
					</Typography>
				</div>
			</div>
			<div className="flex">
				<Button size="large" className="m4 width-100" disabled={false} variant="outlined" onClick={handleClickPrimary}>
					{primaryButtonName}
				</Button>
				<Button size="large" className="m4 width-100" disabled={false} onClick={handleClickSecondary}>
					{secondaryButtonName}
				</Button>
			</div>
		</BottomSheet>
	);
};

export default WrongPinModal;
